import { call, delay, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadTelemetryListBegin, loadTelemetryListFailed, loadTelemetryListSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import {
  BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY,
} from '../../../configs';
import addFilterQueryWithCondition from '../../../utils/addFilterQueryWithCondition';
import { normalizeArrayValue } from '../../../utils/utils';
import { projectDateToTimestamp } from '../../../utils/projectTime';

const toTelemetryTimestampQuery = (value, endOfDay = false) => {
  if (!value) {
    return value;
  }
  if (typeof value === 'number') {
    return value;
  }
  return projectDateToTimestamp(value, endOfDay);
};

const normalizeTelemetryFilter = (filter = {}) => {
  const normalized = { ...filter };

  if (normalized.timestamp_from) {
    normalized.date_from = toTelemetryTimestampQuery(normalized.timestamp_from);
  }
  if (normalized.timestamp_to) {
    normalized.date_to = toTelemetryTimestampQuery(normalized.timestamp_to, true);
  }
  delete normalized.timestamp_from;
  delete normalized.timestamp_to;

  if (normalized.timestamp && !normalized.date_from && !normalized.date_to) {
    const [dateFrom, dateTo] = normalizeArrayValue(normalized.timestamp);
    if (dateFrom) {
      normalized.date_from = toTelemetryTimestampQuery(dateFrom);
    }
    if (dateTo) {
      normalized.date_to = toTelemetryTimestampQuery(dateTo, true);
    }
  }
  delete normalized.timestamp;

  return normalized;
};

export default function* loadTelemetryList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      page_size: limit,
      page,
    };
    const normalizedFilter = typeof filter === 'object' && filter ? normalizeTelemetryFilter(filter) : filter;
    if (typeof normalizedFilter === 'object' && Object.keys(normalizedFilter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(normalizedFilter, pool);
    }
    const url = `${BACKEND_URL}/telemetry`;
    yield put(loadTelemetryListBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse);
    if (dataResponse.status === OK && data?.data) {
      yield put(loadTelemetryListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadTelemetryListFailed());
      yield call(rejectActionPromise(action, data.data));
    }
  } catch (e) {
    yield put(loadTelemetryListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  } finally {
    yield call(resolveActionPromise(action));
  }
}
